import React, { FC } from 'react';
import Modal from '../../ui/Modal';
import { useTranslation } from 'react-i18next';
import Button from '../../ui/Button';

import * as Yup from 'yup';
import { Field, FormikProvider, useFormik } from 'formik';
import Input from '../../ui/Formik/Input';
import { getActions } from '../../../global';

export type OwnProps = {
  isOpen: boolean;
  onClose: () => void;
  onCloseAnimationEnd?: () => void;
  setIsShow?: (value: boolean) => void;
};

const DeleteAccountModal: FC<OwnProps> = ({ isOpen, onClose, setIsShow }) => {
  const { verifyEmailForDeleteAction } = getActions();
  const { t } = useTranslation();
  const validationShema = Yup.object({
    email: Yup.string()
      .required(t('Validation.required_email'))
      .email(t('Validation.valid_email')),
  });
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: validationShema,
    onSubmit: (values) => {
      verifyEmailForDeleteAction({
        username_or_email: values.email,
        action: 0,
        onClose,
        setIsShow,
      });
    },
  });

  return (
    <Modal isOpen={isOpen} className='confirm' onClose={onClose} hasCloseButton>
      <div className='modal-content'>
        <h4>{t('Settings.DeleteAccountConfirm')}</h4>
        <p className='text-secondary'>
          {t('Settings.DeleteAccountDescription')}
        </p>
        <FormikProvider value={formik}>
          <Field
            name='email'
            component={Input}
            label={t('Registration.place_email')}
          />
        </FormikProvider>

        <Button
          className='confirm-dialog-button mb-4'
          type='submit'
          onClick={formik.submitForm}
          disabled={!formik.isValid}
          fullWidth
        >
          {t('Settings.DeleteAccount')}
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteAccountModal;
